export const ENTRY = "/";
export const SIGNIN = "/";
// export const PROTECTED = "/point-allocation";
export const REWARD = "/reward";
export const REWARD_DETAILS = "/reward/:id";
export const PROFILE = "/profile";
